@if (!isLoading && insuranceFlowData) {
  <app-details-header
    [displayId]="headerDisplayId"
    [badges]="headerBadges"
    [customerName]="headerCustomerName"
    [customerDisplayId]="userProfile?.displayId ?? null"
    [accountType]="userProfile?.type ?? null"
    [clientStatus]="userProfile?.clientStatus ?? null"
  />
}
